/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const AlarmWristband = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M9.5 4.5c3 0 5.5 2.5 5.5 5.5s-2.5 5.5-5.5 5.5S4 13 4 10s2.5-5.5 5.5-5.5zm0 9c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5S6 8.1 6 10s1.6 3.5 3.5 3.5zm0-9.7c1.5 0 2.9.5 4 1.4V2.8c0-.4-.3-.8-.8-.8H6.2c-.4 0-.7.3-.7.8v2.4c1.1-.9 2.5-1.4 4-1.4zm0 12.4c-1.5 0-2.9-.5-4-1.4v2.4c0 .4.3.8.8.8h6.5c.4 0 .8-.3.8-.8v-2.4c-1.2.9-2.6 1.4-4.1 1.4z" />
  </svg>
);

export default extendIcon(AlarmWristband);
